var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16107_20901)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4098 28.0967C26.4098 29.3837 25.3663 30.4273 24.0791 30.4273H15.6305C14.3434 30.4273 13.2998 29.3838 13.2998 28.0967V11.395C13.2998 10.108 14.3433 9.06445 15.6305 9.06445H24.0791C25.3662 9.06445 26.4098 10.1079 26.4098 11.395V28.0967ZM21.1714 28.3286C21.1714 29.0555 20.5821 29.6447 19.8551 29.6447C19.1282 29.6447 18.5389 29.0555 18.5389 28.3286C18.5389 27.6017 19.1282 27.0124 19.8551 27.0124C20.5821 27.0124 21.1714 27.6017 21.1714 28.3286ZM16.1829 10.6003H23.5271C23.9388 10.6003 24.2736 10.9193 24.2738 11.3114V25.1933C24.2738 25.585 23.9388 25.9044 23.5271 25.9044H16.1829C15.771 25.9044 15.4363 25.5854 15.4363 25.1933V11.3114C15.4363 10.9196 15.7712 10.6003 16.1829 10.6003Z",
    fill: "#4251DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16107_20901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.d4cc32f33eb26a6448db978c62bc2d2b.svg";
export { ForwardRef as ReactComponent };